export const config = {
    FIREBASE: {
        SERVER_KEY: "AAAAGq5ZT6Y:APA91bEzL_cA9B5r_PHeoaUKc0X1At7i4WXU2cUiz2C6-Jx0nu3T0lptXwswbZSaQqOaU_RS_4hEPhZDxbIaJ3AS-4RTpiGt7EK3pfoTmCv-UIwT66ENif_vm1ZPB6WBG03-jT8XJDs0",
        ADD_TOKEN_URL: "https://us-central1-checkin-notification-260ed.cloudfunctions.net/addToken"
    }
}